import { firestorePlugin } from "vuefire";
import Vue from "vue";

Vue.use(firestorePlugin);
